// extracted by mini-css-extract-plugin
export var applyForm = "apply-form-module--apply-form--EWUDb";
export var applyFormButton = "apply-form-module--apply-form-button--i0cJ3";
export var applyFormContainer = "apply-form-module--apply-form-container--Jn8sv";
export var applyFormContent = "apply-form-module--apply-form-content--udCOT";
export var applyFormContentFields = "apply-form-module--apply-form-content-fields--EbHJc";
export var applyFormTitle = "apply-form-module--apply-form-title--5EgaY";